export default __webpack_public_path__ + "maps-examples-map-snapshotter-thumbnail-480-280d8e684b14d904dc0c520ecb99c1f6.png";